import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "titleName" }
const _hoisted_3 = {
  key: 0,
  class: "loader"
}
const _hoisted_4 = {
  key: 1,
  class: "inputWrapper"
}
const _hoisted_5 = { class: "payment-options" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "error"
}

import { useRoute } from 'vue-router'
  import InfoBlock from '../components/InfoBlock.vue'
  import { Ref, onMounted, ref } from 'vue'
  import { Params } from '@/types'
  import { GrpcWebFetchTransport } from '@protobuf-ts/grpcweb-transport'
  import { AcquiringClient } from '@/generated/acquiring_donate.client'
  import {
    CreatePaymentRequest,
    GetInfoRequest,
    GetInfoResponse,
  } from '@/generated/acquiring_donate'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

  const transport = new GrpcWebFetchTransport({
    baseUrl: window.location.origin,
  })
  const acquiringClient = new AcquiringClient(transport)

  const route: any = useRoute()
  const error = ref(false)
  const isLoading = ref(false)
  const loadingError = ref('')
  const warningMessage = ref('')
  const data = ref<GetInfoResponse>()
  const donateSum = ref()
  const selectedBankService: Ref<number | null> = ref(null)
  const queryParams = ref<Params>({
    workerId: 0,
    serviceId: 0,
    hash: '',
  })

  const getImage = (bankService: number) => {
    switch (bankService) {
      case 0:
        return require('../assets/images/mir.svg')
      case 1:
        return require('../assets/images/sbp.svg')
      default:
        return ''
    }
  }

  const selectOption = (bankService: number | null) => {
    selectedBankService.value = bankService
  }

  const loadData = () => {
    const request = GetInfoRequest.create({ ...queryParams.value })
    acquiringClient
      .getInfo(request)
      .then(({ response }) => {
        data.value = response
      })
      .catch((e) => {
        loadingError.value = decodeURI(e.message)
      })
  }

  const parse = () => {
    if (route.query.w && route.query.g && route.query.h) {
      queryParams.value.workerId = parseInt(route.query.w)
      queryParams.value.serviceId = parseInt(route.query.g)
      queryParams.value.hash = route.query.h
      loadData()
    } else {
      loadingError.value = 'что-то пошло не так'
    }
  }

  const paymentHendler = (bankService: number) => {
    if (donateSum.value) {
      isLoading.value = true
      selectOption(bankService)

      const request = CreatePaymentRequest.create({
        ...queryParams.value,
        amount: donateSum.value,
        bankService,
      })

      acquiringClient
        .createPayment(request)
        .then(({ response }) => {
          window.location.href = response.paymentUrl
          error.value = false
        })
        .catch((e) => {
          warningMessage.value = decodeURI(e.message)
          error.value = true
        })
        .finally(() => {
          isLoading.value = false
        })
    } else {
      warningMessage.value = 'Минимальная сумма 1 Руб'
      error.value = true
    }
  }

  onMounted(() => {
    parse()
  })

return (_ctx: any,_cache: any) => {
  return (!loadingError.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(data.value?.workerName), 1)
        ]),
        _createElementVNode("div", null, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "loader-inner" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((donateSum).value = $event)),
                  required: "",
                  type: "number",
                  placeholder: "введите сумму доната"
                }, null, 512), [
                  [
                    _vModelText,
                    donateSum.value,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value?.bankServices, (option, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["payment-card", { selected: selectedBankService.value === option.bankService }]),
                      onClick: ($event: any) => (paymentHendler(option.bankService))
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedBankService).value = $event)),
                        value: option.bankService,
                        name: "payment-method"
                      }, null, 8, _hoisted_7), [
                        [_vModelRadio, selectedBankService.value]
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          src: getImage(option.bankService),
                          alt: "Payment Method"
                        }, null, 8, _hoisted_8)
                      ])
                    ], 10, _hoisted_6))
                  }), 128)),
                  (error.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(warningMessage.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
        ])
      ]))
    : (_openBlock(), _createBlock(InfoBlock, {
        key: 1,
        color: "rgb(208, 100, 100)",
        text: "произошла ошибка",
        loadingError: loadingError.value
      }, null, 8, ["loadingError"]))
}
}

})